/**
 * The signup form's second appearance, at the end of the argument.
 *
 * The hero catches the reader who arrived convinced; this catches the one who
 * needed the page. It reuses `EmailCaptureForm` whole — including the
 * point-of-collection privacy notice, which FR-016 wants legible wherever an
 * address is typed, so the reuse is a feature and not a duplication to fix.
 * The two instances hold independent mutation state (`useSubscribeEmail` is a
 * plain `useMutation`), which is the right behaviour: a visitor submits one of
 * them, and the server treats a repeat as the idempotent no-op it already is.
 */

import { StyleSheet, View } from "react-native";
import { Text } from "react-native-paper";
import { EmailCaptureForm } from "@/components/marketing/email-capture-form";
import { MarketingSection } from "@/components/marketing/section";
import { SectionHead } from "@/components/marketing/section-head";
import { useAppTheme } from "@/theme/paper-theme";
import { spacing } from "@/theme/tokens";

const SUB =
  "Sparkie is in development for iPhone. Leave an address and we'll write once, when it's ready.";

export function ClosingCta() {
  const theme = useAppTheme();

  return (
    <MarketingSection style={styles.section}>
      <SectionHead eyebrow="Early access" heading="Be first in line." />

      <Text
        variant="bodyLarge"
        style={[styles.sub, { color: theme.colors.onSurfaceVariant }]}
      >
        {SUB}
      </Text>

      <View style={styles.form}>
        <EmailCaptureForm />
      </View>
    </MarketingSection>
  );
}

const styles = StyleSheet.create({
  section: {
    gap: spacing.lg,
    alignItems: "center",
  },
  sub: {
    maxWidth: 520,
    textAlign: "center",
  },
  form: {
    width: "100%",
    alignItems: "center",
  },
});
